export default __webpack_public_path__ + "static/media/dev_orange.png";